import { render, staticRenderFns } from "./report_after.vue?vue&type=template&id=3274cad4&scoped=true&"
import script from "./report_after.vue?vue&type=script&lang=js&"
export * from "./report_after.vue?vue&type=script&lang=js&"
import style0 from "./report_after.vue?vue&type=style&index=0&id=3274cad4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274cad4",
  null
  
)

export default component.exports